import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

/**
 * Custom hook for managing admin reports data
 * Handles fetching reports data with type and period filtering
 */
export const useAdminReports = (initialReportType = 'bookings', initialPeriod = 'month') => {
  const [reportType, setReportType] = useState(initialReportType);
  const [period, setPeriod] = useState(initialPeriod);

  const reportTypeOptions = [
    { value: 'bookings', label: 'Bookings Report' },
    { value: 'revenue', label: 'Revenue Report' },
    { value: 'users', label: 'Users Report' },
    { value: 'vendors', label: 'Vendors Report' },
    { value: 'payments', label: 'Payments Report' }
  ];

  const periodOptions = [
    { value: 'week', label: 'Last Week' },
    { value: 'month', label: 'Last Month' },
    { value: 'quarter', label: 'Last Quarter' },
    { value: 'year', label: 'Last Year' },
    { value: 'all', label: 'All Time' }
  ];

  const { data: reportResponse, isLoading, error, refetch } = useQuery({
    queryKey: ['adminReports', reportType, period],
    queryFn: async () => {
      const response = await api.get(`/admin/reports?type=${reportType}&period=${period}`);
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // Data considered fresh for 5 minutes
  });

  const report = reportResponse?.data || {};

  return {
    // Data
    report,
    isLoading,
    error,
    
    // Report type management
    reportType,
    setReportType,
    reportTypeOptions,
    
    // Period management
    period,
    setPeriod,
    periodOptions,
    
    // Actions
    refetch
  };
};

